export default __webpack_public_path__ + "static/media/spider_awards.0004b40f.png";